import React from 'react';
import { getTardiness } from '../../services/timesheetService';
import PresetReportPage from './components/PresetReportPage';

// AKM POC §5.15 / §7 — Devam Paneli'nden panel süzgeçleriyle açılabilir; ortak süzgeç seti, TA ekip kapsamı ve sunucu
// tarafı Excel / PDF dışa aktarma ortak gövdede (PresetReportPage).
export default function TardinessPage() {
  return <PresetReportPage fetchFn={getTardiness} titleKey="pdks.tardinessTitle" exportUrl="/v1/ta/reports/tardiness/export" />;
}
